import { AppRouteProps } from "@bsm/component";
import React from "react";

const UserListContainer = React.lazy(() => import('./containers/UserListContainer'))
export const UserListRoutes: Array<AppRouteProps> = [
    {
        path: 'user/list',
        title: 'Harea.Userlist.Title',
        element: <UserListContainer />,
        roles: ["ORGANISATION_LICENSE"]
    }
]